import React from 'react';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import FormControl from 'react-bootstrap/FormControl';
import Select from 'react-select';

import WhatsAppAPI from '../../api/WhatsAppAPI';
import Const from '../../util/Constants';
import Util from '../../util/Util';
import LocalStorage from '../../util/LocalStorage';
import ApiUiController from '../../controller/ApiUiController';

import './WhatsAppPopup.css';

class WhatsAppPopup extends React.Component {

  constructor(props) {
    super(props);
    this.options = LocalStorage.getWhatsAppTemplate(LocalStorage.Options);
    this.phones = [];
    if(props.data && props.data.phone && props.data.phone !== '' && props.data.phone !== '~~') {
      this.phones = props.data.phone.substring(1, props.data.phone.length - 1).split(Const.Opt)
        .map( value => { return { label: value, value: value.substring(1).replace(Const.Hhn, '') }});
    }
    const phone = this.phones.length > 0 ? this.phones[0] : null;
    this.whatsapp = { id: 0, type: 1, model_no: props.model.model_no, model_id: props.data ? props.data.id : 0 };
    this.state = { inApiCall: false, temp: null, phone, text: '', values: [] };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(props.data && this.props.data && props.data.id !== this.props.data.id) {
      this.phones = [];
      if(props.data.phone && props.data.phone !== '' && props.data.phone !== '~~') {
        this.phones = props.data.phone.substring(1, props.data.phone.length - 1).split(Const.Opt)
          .map( value => { return { label: value, value: value.substring(1).replace(Const.Hhn, '') }});
      }
      this.whatsapp = { id: 0, type: 1, model_no: props.model_no, model_id: props.model_id };
      this.setState({ ...this.state, phone: this.phones.length > 0 ? this.phones[0] : null });
    }
  }

  onChange = temp => {
    const data = temp ? Util.templateToData(temp.text, this.props.data, this.props.model.fields, true) : '';
    temp.body_json = temp.body_json ? JSON.parse(temp.body_json) : {};
    temp.body_json = Util.templateToDataInObject(temp.body_json, this.props.data, this.props.model.fields);
    this.setState({ ...this.state, temp, template: temp.text, text: data.template, values: data.values });
  }

  onValueChange = evt => this.setState({ ...this.state, text: evt.target.value });
  onPhone = phone => this.setState({ ...this.state, phone });

  onSave = () => {
    if(this.state.text === '') { 
      Util.showNotification('Error', 'Sms is empty', 'danger'); 
      return; 
    }
    this.setState({ ...this.state, inApiCall: true });

    const temp = this.state.temp;
    if(temp && temp.api_provider) {
      const body = { ...this.whatsapp, phone: this.state?.phone?.label, text: this.state.text, 
        template: { ...this.state.temp } , values: this.state.values
      };
      WhatsAppAPI.send(body, this.onSaved, this.failure);
    } else {
      const text = encodeURIComponent(this.state.text);
      let url =  this.state.phone ? `phone=${this.state.phone.value}` : '';
      url = url + (url !== '' ? '&' : '') + `text=${text}`;
      url = `https://api.whatsapp.com/send?${url}`;
      this.props.onHide();
      window.open(url, '_blank');
    }
  }

  onSaved = () => {
    Util.showNotification('Successful', 'WhatsApp message sent successfully', 'success');
    this.setState({ ...this.state, inApiCall: false });
    this.props.onHide();
    if(this.props.reload) {
      this.props.reload();
    }
  }

  failure = res => {
    Util.showNotification('Failed', res.message, 'danger');
    this.setState({ ...this.state, inApiCall: false });
  }

  render() {
    return (
      <Modal {...this.props} size="md" aria-labelledby="contained-modal-title-vcenter" centered >
        
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">WhatsApp</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <ApiUiController inApiCall={this.state.inApiCall}>
              <div className="col">
                <div className="form-group">
                  <label>Select Template</label>
                  <Select value={this.state.temp} onChange={this.onChange}
                    options={this.options} isSearchable={true} isClearable={true} />
                </div>
              </div>

              <div className="col">
                <div className="form-group">
                  <label>Select Phone</label>
                  <Select value={this.state.phone} onChange={this.onPhone}
                    options={this.phones} isSearchable={true} isClearable={true} />
                </div>
              </div>
              
              <div className="col">
                <div className="form-group">
                  <label>WhatsApp Text</label>
                  <FormControl as="textarea" placeholder="Text" className="mr-sm-2"
                    value={this.state.text} onChange={this.onValueChange} rows={3} />
                </div>
              </div>
            </ApiUiController>
          </Form>
        </Modal.Body>
        <Modal.Footer><Button onClick={this.onSave}>Submit</Button></Modal.Footer>
      </Modal>
    );
  }
}
export default WhatsAppPopup;